// ============================================
// アコーディオン処理（details & summary）
// ============================================

/**
 * アニメーションの時間とイージング
 */
const ANIM_TIMING = {
	duration: 400,
	easing: 'cubic-bezier(0, 0, 0, 1)',
};

/**
 * アコーディオンを閉じるときのキーフレーム
 * @param {HTMLElement} content - コンテンツ要素
 */
const closingKeyframes = (content) => [
	{
		height: content.offsetHeight + 'px',
		opacity: 1,
	},
	{
		height: 0,
		opacity: 0,
	},
];

/**
 * アコーディオンを開くときのキーフレーム
 * @param {HTMLElement} content - コンテンツ要素
 */
const openingKeyframes = (content) => [
	{
		height: 0,
		opacity: 0,
	},
	{
		height: content.offsetHeight + 'px',
		opacity: 1,
	},
];

/**
 * アコーディオンを初期化
 * data-accordion 属性を持つ details 要素に対してアニメーションを付与する
 */
export function initAccordion() {
	const details = document.querySelectorAll('[data-accordion]');
	if (!details.length) return;

	details.forEach((el) => {
		const summary = el.querySelector('summary');
		const content = summary.nextElementSibling;
		if (!summary || !content) return;

		/* アニメーション実行中の状態管理 */
		let runningAnim = null;

		summary.addEventListener('click', (e) => {
			e.preventDefault();

			/* 連打防止: 実行中のアニメーションがあればキャンセルして即完了 */
			if (runningAnim) {
				runningAnim.cancel();
				runningAnim = null;
			}

			if (el.open) {
				/* --- 閉じる --- */
				const anim = content.animate(closingKeyframes(content), ANIM_TIMING);
				runningAnim = anim;

				setTimeout(function () {
					el.removeAttribute('open');
				}, 30);

				anim.onfinish = () => {
					runningAnim = null;
				};
			} else {
				/* --- 開く --- */
				el.setAttribute('open', 'true');

				const anim = content.animate(openingKeyframes(content), ANIM_TIMING);
				runningAnim = anim;

				anim.onfinish = () => {
					runningAnim = null;
				};
			}
		});
	});
}
